import React, {useState} from "react";
import {GetDarInfo_Query, PersonInfo, getDarInfoResponse} from "../../interfaces/getDarInfo_interface";
import {RunDarQuery} from "../../services/getDar.service";
import {Account} from "../../interfaces/auth_interface";
import {getUser, isArrestShow} from "../../services/auth.service";
import GRAILReferralSearch from "../../components/GRAIL/GRAIL_ReferralSearch";
import SearchResults from "../../components/GRAIL/_searchResultsGRAILReferral";

function GRAILReferral() {
    let [darTbl, setDarTbl] = useState<PersonInfo[]>([])
    let [user, setUser] = useState<Account>(getUser())
    let [noData, setNoData] = useState<boolean>(false)

    const SubmitSearch = async (params:any, dateType:string, dateRange:boolean, dropDowns:any) => {
        console.log(params)
        let search_query: GetDarInfo_Query = {
            "QueryType": "N",
            "Dept": user.Dept,
            "EmpID": user.EmpID,
            "DeptORI": user.DeptORI,
            "DateRange": dateRange,
            "DateTypeValue": (dateType === "Entry Date") ? 0 : 1,
            "FromDate": params?.fromDate?.toLocaleString(),
            "ToDate": params?.toDate?.toLocaleString(),
            "SearchType": 'AND',
            "IndicatorOn": true,
            "TopArrestNumber": 0,
            "FNames": params.FName ? params.FName.split(',') : [],
            "MNames": params.MName ? params.MName.split(',') : [],
            "LNames": params.LName ? params.LName.split(',') : [],
            "DOBs": params.DOB ? params.DOB.split(',') : [],
            "SEX":[],
            "Address": "",
            "Cities": [],
            "States": [],
            "Zip": "",
            "Statutes": [],
            "Gang": [],
            "FBIs": params.FBI ? params.FBI.split(',') : [],
            "SBIs": params.SBI ? params.SBI.split(',') : [],
            "DLNos": [],
            "PlateNos": params.eCDR ? params.eCDR.split(',') : [],
            "VINs": [],
            "AgencyArrested": [],
            "PoliceStopDept": [],
            "Indicators": dropDowns.Indicator ? dropDowns.Indicator: [],
            "Latitude": null,
            "Longitude": null,
            "Radius": 0,
            "ResidentCounty": params.County ? params.County : [], // Referral County
            "ArrestedCounty": params.RTCC ? params.RTCC.split(',') : [], // RTCC Location
            "Arrest_Type": params.Adopted ? params.Adopted.split(',') : [], // Adopted
            "CaseNumbers": params.Status ? params.Status.split(',') : [], //Status
            "SSN": params.SSN ? params.SSN.split(',') : [],
            "FTSIDs": [],
        }
        let qRes:getDarInfoResponse = await RunDarQuery(search_query)
        setDarTbl([])
        setDarTbl(qRes.AnyTable)
        if (qRes?.AnyTable?.length === 0) {
            setNoData(true)
        }
        else {
            setNoData(false)
        }
    }

    return (
        <div>
            {isArrestShow()?
                <>
                    <GRAILReferralSearch SubmitSearch={SubmitSearch}/>
                    {!noData ? <SearchResults Persons={darTbl} GetReferrals={SubmitSearch}/> : <div className="font-bold text-lg ml-5">NO Matching Records Found</div>}
                </>
                :<></>}
        </div>
    );
}

export default GRAILReferral;